import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css'; 

import Home from './Inicio/Home';
import LoginPage from './Login/LoginPage'; 
import Registro from './Login/Registro';
import PaquetesPage from './Servicios/PaquetesPage';
import DjPage from './Servicios/DjPage';
import DetallePaquete from './Servicios/DetallePaquete';
import HorariosPage from './Servicios/HorariosPage';
import Pago from './Servicios/Pago';
import DashboardAdmin from './Inicio/components/admin/DashboardAdmin';
import DashboardDJ from './Inicio/components/djP/DashboardDJ';
import RecuperarCuenta from './Login/RecuperarCuenta';
import UserProfile from './Perfil/UserProfile';
import RegistroUbicacionPage from './Servicios/RegistroUbicacionPage';

// 🤖 Creamos un componente interno para controlar el botón condicional
function BotonWhatsAppCondicional() {
  const location = useLocation();

  // Condición: El botón solo existirá en el HTML si la ruta actual es exactamente "/"
  if (location.pathname !== '/') {
    return null; 
  }

  return (
    <a 
      href="https://wa.me/906131514" 
      className="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
    </a>
  );
}

function App() {
  return (
    <Router>
      <div className="App"> 
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} /> 
          <Route path="/registro" element={<Registro />} /> 
          <Route path="/paquetes" element={<PaquetesPage />} />
          <Route path="/dj" element={<DjPage />} />
          <Route path="/paquetes/detalle/:id" element={<DetallePaquete />} />
          <Route path="/horarios" element={<HorariosPage />} />
          <Route path="/pago/:id/:tipo" element={<Pago />} />
          <Route path="/admin" element={<DashboardAdmin />} />
          <Route path="/dj-dashboard" element={<DashboardDJ />} />
          <Route path="/recuperar-cuenta" element={<RecuperarCuenta />} />
          <Route path="/perfil" element={<UserProfile />} />
          <Route path="/registro-ubicacion/:paqueteId/:tipo" element={<RegistroUbicacionPage />} />
        </Routes>

        {/* 🟢 Renderizamos el botón condicional aquí abajo */}
        <BotonWhatsAppCondicional />
      </div>
    </Router>
  );
}

export default App;